export default __webpack_public_path__ + "static/media/up-arrow.da9b8b1c.svg";